import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss']
})
export class CookiePolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    document.getElementById('nb-global-spinner').style.display = 'none';
  }

}
